module.exports = function anonymous(locals, escapeFn, include, rethrow
/**/) {
"use strict";
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
        .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = [], __append = __output.push.bind(__output);
    ; __append("<div class=\"my-4\"> <div class=\"justify-content-between d-flex\"> <div class=\"d-flex\"> <h4 class=\"m-0 mr-3\">")
    ; __append(escapeFn( locals.name ))
    ; __append("</h4> <span> ")
    ;  _.each(locals.links, function(link) { 
    ; __append(" <a href=\"")
    ; __append(escapeFn( link.href ))
    ; __append("\" class=\"btn btn-sm btn-clear d-none d-md-inline-block\" target=\"_blank\">")
    ; __append(escapeFn( link.name ))
    ; __append("</a> ")
    ;  }); 
    ; __append(" ")
    ;  _.each(locals.subViews, function(subView, idx) { 
    ; __append(" <span id=\"")
    ; __append(escapeFn( locals.computeSubViewID(idx) ))
    ; __append("\"></span> ")
    ;  }); 
    ; __append(" </span> </div> <span class=\"dropdown\"> <a href=\"#\" class=\"dropdown-toggle\" data-toggle=\"dropdown\" role=\"button\" aria-haspopup=\"true\" aria-expanded=\"false\"> <i class=\"fa fa-life-ring\"></i> Help </a> <span class=\"dropdown-menu dropdown-menu-right\"> <a class=\"dropdown-item\" href=\"/docs/api\">Documentation</a> <a class=\"dropdown-item\" href=\"/knowledgebase\">Knowledge Base</a> <a class=\"dropdown-item\" href=\"/support\">Support</a> </span> </span> </div> </div> ")
  return __output.join("");

}


//////////////////
// WEBPACK FOOTER
// ./app/components/page_header/template.ejs
// module id = 1701
// module chunks = 1